import { observer } from 'mobx-react-lite';
import Button from '../components/button';
import ProfilePictureInput from '../components/profilePictureInput';
import { AppPage } from '../components/appPage';
import { storageService } from '../services/storageService';
import { appLocalStore } from '../stores/appLocalStore';

const UserSetupModalComponent: React.FC = observer(() => {

  const handleDone = () => {
    if (appLocalStore.modals.isUserSetupModalFormValid) {
      // Save player name and profile picture to storage
      storageService.setUserName(appLocalStore.userName);
      storageService.setUserAvatar(appLocalStore.userAvatar!);
      appLocalStore.navigateToPage("lobby");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && appLocalStore.modals.isUserSetupModalFormValid) {
      handleDone();
    }
  };

  return (
    <AppPage
      className="app--bgBlue"
      content={
        <div className="bg-[var(--bg-primary)] p-10 rounded-2xl shadow-2xl max-w-md w-[90%]">
          <p className="text-[var(--text-secondary)] text-base m-0 mb-2 text-center">Welcome to</p>
          <h1 className="text-[var(--text-primary)] text-3xl font-bold m-0 mb-2 text-center">Are We Werewolf?</h1>
          <p className="text-[var(--text-secondary)] text-base m-0 mb-8 text-center">
            Set up your profile to begin<br />
            {/* No cloud storage - Not stored online*/}
            <span className="text-sm opacity-75 leading-none">(Photo only shared with players • Not stored online)</span>
          </p>
          <div className="flex flex-col gap-4">
            <ProfilePictureInput
              value={appLocalStore.userAvatar}
              onChange={(picture) => appLocalStore.action(_ => _.userAvatar = picture)}
            />

            <input
              type="text"
              className="px-4 py-3 text-base border-2 border-[var(--input-border)] rounded-lg outline-none transition-colors bg-[var(--input-bg)] text-[var(--text-primary)] focus:border-[var(--input-border-focus)] placeholder:text-[var(--text-secondary)]"
              placeholder="Enter your name"
              value={appLocalStore.userName}
              onChange={(e) => appLocalStore.action(_ => _.userName = e.target.value)}
              onKeyPress={handleKeyPress}
              maxLength={20}
              autoFocus
            />

            <Button
              onClick={handleDone}
              disabled={!appLocalStore.modals.isUserSetupModalFormValid}
              fullWidth
            >
              Done
            </Button>
          </div>
        </div>
      }
    />
  );
});

export default UserSetupModalComponent;
